import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBox, FDHeadlineText, FDIcon, FDPrimaryActionButton, FDStack, FDStat,
} from '@facet-wealth/design';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dispatchNextUpItemDetailUpdated } from 'Hooks/useRefreshEvent';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useListDetailViewContext } from 'Components/ComponentLibrary/Organisms/ListDetailView/Context';

const FacetPlanProposalNextUpAccountDetailItemLayout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();
  const { setListItemResource } = useListDetailViewContext();

  const handleSubmit = async () => {
    try {
      const res = await onSubmit();
      if (res.included()?.head()) {
        setListItemResource(res.included().head());
      }
      dispatchNextUpItemDetailUpdated();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  return (
    <FDStack direction="column" spacing={2} alignItems="flex-start" justifyContent="flex-start">
      <FDHeadlineText value={resource.attr('title') ?? ''} />
      <FDBox width="100%">
        <FDStack direction="row" spacing={4} alignItems="center" justifyContent="flex-start">
          <FDStack direction={'row'} spacing={2} alignItems="center" justifyContent="flex-start">
            <MetaField attr="accountsAllocation" />
            {resource.attr('accountsAllocation') && <FDIcon icon={'arrowRight'} color={'success'} />}
            <FDStack direction={'row'} justifyContent="flex-start">
              {resource.attr('accountsAllocation') && (
              <FDStack height={22} direction={'column'} justifyContent={'center'}>
                <FDIcon icon={'checkCircleIcon'} color={'success'} size={'sm'} />
              </FDStack>
              )}
              <MetaField attr="allocation" />
            </FDStack>
          </FDStack>
          { !resource?.meta().field('modelAttribute')?.attr('hidden') && <FDStat label={resource.metaField('modelAttribute').attr('prompt')} value={resource.attr('modelAttribute')} /> }
          { resource.attr('alternativeIncomeAllocation') && <FDStat label={resource.metaField('alternativeIncomeAllocation').attr('prompt')} value={resource.attr('alternativeIncomeAllocation')} /> }
          { !resource?.meta().field('transferTotal')?.attr('hidden') && <FDStat label={resource.metaField('transferTotal').attr('prompt')} value={resource.attr('transferTotal')} /> }
          { !resource?.meta().field('allocationTotal')?.attr('hidden') && <FDStat label={resource.metaField('allocationTotal').attr('prompt')} value={resource.attr('allocationTotal')} /> }
        </FDStack>
      </FDBox>
      {resource.meta().canSubmit() && <FDPrimaryActionButton
        onClick={handleSubmit}
        label="Submit Changes"
        loading={saving}
        disabled={saving || !resource.isDirty()}
      />}
    </FDStack>
  );
};

FacetPlanProposalNextUpAccountDetailItemLayout.propTypes = {
};

FacetPlanProposalNextUpAccountDetailItemLayout.defaultProps = {
};

export default FacetPlanProposalNextUpAccountDetailItemLayout;
